import get from "lodash-es/get";

export const formatErrorMessage = (e: any, fallback: string = "An unknown error occurred") =>
  get(e, "response.errors.detail", get(e, "response.body.message", get(e, "message", fallback)));
